import { create } from "zustand";
import {IOutletColor} from "entities/outletColor/model/types.ts";
import {COLORS} from "shared/consts";


export const useOutletColorStore = create<IOutletColor>((set, get) => ({
        defaultColor: COLORS.BG.PAGE_FILLED,
        currentColor: "",
        setColor: (color: string) => {
            set({currentColor: color})
        },
        resetColor: () => {
            set({currentColor: get().defaultColor})
        }
    }
))